export const AMOUNT_BILL = 'amount';
export const PHONE_NUMBER = 'phoneNumber';
export const CUSTOMER_NUMBER = 'customerNumber';
export const PREFIX = 'prefix';
export const BILLER_PAGE = 'billerPage';
export const BILLER_CACHE = 'billerCache';
export const SERVICE_CACHE = 'serviceCache';
export const APP_ENTRY_POINT = 'ALL_BILLER';

export const CACHE_CUSTOMER_NUMBER = 'cacheCustomerNumber';
export const CACHE_AMOUNT = 'cacheAmount';
export const CACHE_FROM_TNC = 'cacheFromTnc';
export const CACHE_FROM_PAYMENT = 'cacheFromPayment';

export const BILLER_TYPE = {
  EWALLET: 'e-wallet',
};

export const PAY_METHOD = {
  BALANCE: 'BALANCE',
  DEBIT_CARD: 'DEBIT_CARD',
  NET_BANKING: 'NET_BANKING',
  DIRECT_DEBIT_DEBIT_CARD: 'DIRECT_DEBIT_DEBIT_CARD',
};

export const PAY_METHOD_SECTION = {
  BALANCE: 'BALANCE',
  SAVED_CARD: 'SAVED_CARD',
  ADD_CARD: 'ADD_CARD',
};

export const ITERATE_RETRY = 0;
